//import Libraries
import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

// import Components
import { Collapse, Row, Col, Input,  Button } from 'reactstrap'
import SubCategory from './SubCategory';
import UpDownTransitionArrow from '../../../../components/UpDownTransitionArrow/UpDownTransitionArrow';

import * as categoryActions from '../actions/categoryActions';

//import Styles
import './Category.css'

class MainCategory extends Component {
    constructor(props) {

        super(props);

        const { category } = props;

        this.state = {
            collapse : true,
            editing : false,

            koText : category.text['ko'],
            enText : category.text['en'],
        }
    } 

    toggleEditing= () => {
        if(this.state.editing) {
            this.props.makeEditDoneAnything();
            this.setState({
                editing : false,
                koText : this.props.category.text['ko'],
                enText : this.props.category.text['en']
            })
        } else {
            if(this.props.makeEditAnything()) {
                this.setState({
                    editing : true,
                    koText : this.props.category.text['ko'],
                    enText : this.props.category.text['en']
                })
            }
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    toggleCollapse = (e) => {
        if (!e.target.className.includes('btn')) {
            this.setState(prevState => ({
                collapse: !prevState.collapse
            }))
        }
    }

    render(){
        const {category, index, subCategory, products} = this.props;

        const sortedSubCategory = subCategory[index] && subCategory[index].sort((a, b) => {
            return a.text.order - b.text.order;
        });

        return (
            <div className="category">
                <div className="main-category" onClick={this.toggleCollapse}>
                    <Row>
                        {
                            this.state.editing ? 
                                <Col xs="9" className="title">
                                    <Input
                                        type="text"
                                        name="koText"
                                        value={this.state.koText}
                                        onChange={this.handleOnChange}
                                        placeholder="한글 대분류"
                                        bsSize="sm"
                                    />
                                    <Input
                                        type="text"
                                        name="enText"
                                        value={this.state.enText}
                                        onChange={this.handleOnChange}
                                        placeholder="English big category"
                                        bsSize="sm"
                                    />
                                </Col>
                                : 
                                <Col xs="9" className="title"><h5>{this.props.category.text['ko']} / {this.props.category.text['en']}</h5></Col>
                        }
                        <Col xs="2">
                            <Button
                                onClick={() => {
                                    if(this.state.editing) {
                                        this.props.onUpdateMainCategory(
                                            category.id, {
                                                ko : this.state.koText,
                                                en : this.state.enText
                                            });
                                    }
                                    this.toggleEditing();
                                }}
                                color="warning"
                                size="sm"
                                outline
                            >
                                {
                                    this.state.editing ? "확인" : "편집"
                                }
                            </Button>
                            <Button
                                onClick={ () => {
                                    this.state.editing ? this.toggleEditing() : this.props.onRemoveMainCategory(category.id);
                                }}
                                color="danger"
                                size="sm"
                                outline
                            >
                                {
                                    this.state.editing ? "취소" : "삭제"
                                }
                            </Button>

                        </Col>
                        <Col xs="1">
                            <UpDownTransitionArrow className="text-right" up={this.state.collapse}/>
                        </Col>
                    </Row>
                </div>
                <Collapse isOpen={this.state.collapse}>
                {
                    sortedSubCategory && 
                    sortedSubCategory.map((sub, subIndex) => {
                        let filteredProducts = products.filter((product, index) => {
                            if(product.category.subCategory === subIndex) {
                                return true;
                            }
                        })

                        let sortedProducts = filteredProducts.sort((a, b) => {
                            if(a.order != undefined && b.order !== undefined) {
                                return a.order - b.order;
                            }
                        })

                        return (
                            <SubCategory 
                                makeEditAnything={this.props.makeEditAnything}
                                makeEditDoneAnything={this.props.makeEditDoneAnything}
                                category={sub}
                                mainId={category.id}
                                mainIndex={index}
                                index={subIndex}
                                products={sortedProducts}
                                key={subIndex}
                            />
                        );
                    })
                }
                    <div 
                        className='sub-category-add-btn'
                        onClick={() => {
                            if(this.props.makeEditAnything()) {
                                this.props.makeEditDoneAnything();
                                this.props.onAddSubCategory(category.id)
                            }
                        }}
                    >
                        세부항목 추가
                    </div>
                </Collapse>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        subCategory : state.category.subCategory
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateMainCategory : (id, text) => {
            dispatch(categoryActions.updateMainCategory(id, text));
        },
        onRemoveMainCategory : (id) => {
            dispatch(categoryActions.removeMainCategory(id));
        },
        onAddSubCategory : (id) => {
            dispatch(categoryActions.addSubCategory(id))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainCategory);


// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/MainCategory.js